import { translations } from '../translations';
import type { Language } from '../translations';

export function useTranslation(language: Language) {
  return {
    t: (section: keyof typeof translations[Language], key: string): string => {
      const sectionTranslations = translations[language]?.[section];
      if (!sectionTranslations) {
        console.warn(`Missing translations for section "${section}" in language "${language}"`);
        return translations.en[section]?.[key] || key;
      }
      return sectionTranslations[key] || translations.en[section]?.[key] || key;
    }
  };
}